import { SharedGridConfig } from "app/modules/shared/ag-grid/shared-grid-state/shared-grid.model";

export class SetTemplateType {
  static readonly type = '[Templates] Set Template Type';
  constructor(public payload: { templateType: string }) { }
}

export class GetTemplates {
  static readonly type = '[Templates] Get Templates';
  constructor(public payload: { gridUUID: string }) { }
}

export class SetTemplateFormGridConfig {
  static readonly type = '[Templates] Set Template Form Grid Config';
  constructor(public payload: { gridUUID: string; secondGridConfig: SharedGridConfig; }) { };
}

export class GetFormActionDropdowns {
  static readonly type = '[Templates] Get Action Dropdowns';
  constructor(public payload: string[]) { }
}

export class OnSetNewGridEntry {
  static readonly type = '[Templates] On Set New Grid Entry';
}

export class OnRemoveGridEntry {
  static readonly type = '[Templates] On Remove Grid Entry';
  constructor(public payload: any) { }
}

export class GetDistinctDocuments {
  static readonly type = '[Templates] Get Disinct Documents';
  constructor(public payload: { gridUUID: string }) { }
}

export class OnSubmitValues {
  static readonly type = '[Templates] On Submit Values';
}

export class SetSelectedTemplate {
  static readonly type = '[Templates] Set Selected Template';
  constructor(public payload: { type: string, key: string, stakeholders: string[] }) { }
}

export class IsSelectedGridDataEditable {
  static readonly type = '[Templates] Is Selected Grid Data Editable';
  constructor(public payload: boolean) { }
}

export class SetSelectedTemplateRowData {
  static readonly type = '[Templates] Set Selected Template Row Data';
  constructor(public payload: { _id: string, md5Checksum: string }) { }
}

export class OnRemoveTemplate {
  static readonly type = '[Templates] On Remove Template';
  constructor(public payload: any) { }
}

export class SetIsNew {
  static readonly type = '[Templates] Set Is New';
  constructor(public payload: boolean) { }
}

export class SetNameMap {
  static readonly type = '[Templates] Set Name Map';
}

export class SetIsGeneric {
  static readonly type = '[Templates] Set Generic Template';
  constructor(public payload: boolean) { }
}

export class SetIsClone {
  static readonly type = '[Templates] Set Clone Template';
  constructor(public payload: boolean) { }
}

export class SavePurchaseShippingTerms {
  static readonly type = '[Templates] Save Purchase Shipping Terms';
}

export class SaveSalesShippingInstructions {
  static readonly type = '[Templates] Save Sales Shipping Terms'
}

export class SaveSingleForm {
  static readonly type = "[Templates] Save Single Form Input"
}

export class CreateSingleForm {
  static readonly type = '[Templates] Save Single Form';
}

export class GetFormData {
  static readonly type = '[Templates] Get FormData';
}

export class SetStakeholderDropdowns {
  static readonly type = '[Templates] Set Stakeholder Dropdowns'
}

export class SetSelectedStakeholders {
  static readonly type = '[Templates] Set Selected Stakeholders'
  constructor(public payload: string[]) { }
}

export class SetSelectedTemplateComponent {
  static readonly type = '[Templates] Set Selected Template Component';
  constructor(readonly payload: any) { }
}
